import Axios from "axios";
import { API_ENDPOINT_CONNECT } from "config";
import { getIdToken } from "@/lib/aws-amplify/auth";

export const AXIOS_INSTANCE_CONNECT = Axios.create({
  baseURL: API_ENDPOINT_CONNECT,
  headers: {
    "Content-Type": "application/json",
  },
  paramsSerializer: {
    // 配列のsearchParamsを?key=value&key=valueの形式にする
    indexes: null,
  },
});

AXIOS_INSTANCE_CONNECT.interceptors.request.use(
  async (config) => {
    config.headers.Authorization = await getIdToken();
    return config;
  },
  (err) => {
    return Promise.reject(err instanceof Error ? err : new Error(String(err)));
  }
);
